import React from 'react'

const RegionalMemberCardLeft = (props) => {

    return (
        <>
            <div className="member-card-left">
                <h2>{props.fullname}</h2>
                <img src={props.imageUrl} alt={props.imageAlt} />
                <p>{props.pf_number}</p>
            </div>
        </>
    )
}

export default RegionalMemberCardLeft